const React = require('react');
const Ripple = require('../Ripple');


module.exports = (props) => {
  return (
    <Ripple
      {...props}
      className={`dn h52 ttU r4 layoutRow fhaC fvaC ph15 lts.015em tdN olN usN
        bgF.06 bgF.12:not[.disabled]:h cF lh fw6 f16 ovH
        ff$2 (o50|crNA).disabled*2 `
        + (props.className || '')}
    />
  );
};
